import { IUser } from "../../../../../@types";

export const getUserFullName = (user: IUser | null) => {
  const firstName = user?.userDetails.firstName
    ? user?.userDetails.firstName
    : user?.displayName?.split(" ")?.[0];
  const lastName = user?.userDetails.lastName
    ? user?.userDetails.lastName
    : user?.displayName?.split(" ")?.[user?.displayName.split(" ").length];
  return { firstName, lastName };
};

export enum CreditCode {
  COACHING_FULL = "01",
  COACHING_MINUTES = "02",
  CV_CHECK = "03",
  LINC = "04",
  EXTERNAL_SERVICES = "05",
  WEBINAR = "06",
  MANUAL = "07",
  LINKEDINPACKAGE = "08",
}

export const MAX_CHARACTERS = 10000;
